export const getRecommendations = '/recipes/getRecommendations';
export const getNewRecipes = '/recipes/newRecipes';
